import { Form, Input } from 'antd';
import FormItem from 'components/FormItem';

function Step1Setup({ form }) {
  return (
    <Form form={form} layout="vertical">
      <FormItem
        name="name"
        label="Segment Name"
        rules={[{ required: true, message: 'Segment name is required' }]}
      >
        <Input
          placeholder="This name will be visible in reports, campaigns, and growth rules."
          size="large"
        />
      </FormItem>
      <FormItem name="description" label="Description">
        <Input.TextArea
          placeholder="Explain what defines this group and how it will be used."
          rows={4}
        />
      </FormItem>
    </Form>
  );
}

export default Step1Setup;
